/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Occupation_SedentaryInputs */

const en_us2_occupation_sedentary = /** @type {(inputs: Occupation_SedentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitting most of the day`)
};

const pt_br2_occupation_sedentary = /** @type {(inputs: Occupation_SedentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sentado a maior parte do dia`)
};

const es_419_occupation_sedentary = /** @type {(inputs: Occupation_SedentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sentado la mayor parte del día`)
};

const pt_pt2_occupation_sedentary = /** @type {(inputs: Occupation_SedentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sentado a maior parte do dia`)
};

const fr_fr2_occupation_sedentary = /** @type {(inputs: Occupation_SedentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surtout en position assise`)
};

const de_de2_occupation_sedentary = /** @type {(inputs: Occupation_SedentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fast den ganzen Tag im Sitzen`)
};

const it_it2_occupation_sedentary = /** @type {(inputs: Occupation_SedentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla scrivania quasi tutto il giorno`)
};

/**
* | output |
* | --- |
* | "Sitting most of the day" |
*
* @param {Occupation_SedentaryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const occupation_sedentary = /** @type {((inputs?: Occupation_SedentaryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Occupation_SedentaryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_occupation_sedentary(inputs)
	if (locale === "es-419") return es_419_occupation_sedentary(inputs)
	if (locale === "pt-PT") return pt_pt2_occupation_sedentary(inputs)
	if (locale === "fr-FR") return fr_fr2_occupation_sedentary(inputs)
	if (locale === "de-DE") return de_de2_occupation_sedentary(inputs)
	if (locale === "it-IT") return it_it2_occupation_sedentary(inputs)
	return en_us2_occupation_sedentary(inputs)
});
export { occupation_sedentary as "occupation.sedentary" }